/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/17/20
 * Time: 12:35 PM
 */
import React, {Component} from 'react';
import './CourseSlides.scss';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import * as constants from "../../const/constants";
// import * as commonFunc from "../../utils/commonFunc";
import {withRouter} from "react-router";
import * as actionCreator from "../../store/domain/classes/action";
import {connect} from "react-redux";
// import MonthSelector from "../MonthPicker/MonthSelector";
import * as actionSpinnerCreator from "../../store/domain/spinner/action";
import * as actionModalCreator from "../../store/domain/modal/action";
// import * as commonFunc from "../../utils/commonFunc";
// // import {MDBContainer, MDBScrollbar} from "mdbreact";
import {lang, language} from "../../const/language";
import * as commonFunc from "../../utils/commonFunc";
import {getSliderSetting} from "../../utils/commonFunc";
import swal from "sweetalert";

import webConfig from '../../config/WebConfig'
import GetPaymentModel from "../Modals/payeMentDetailsCourse/getPaymentModel";
import GetCoursePaymentDetails from "../Modals/payeMentDetailsCourse/getCoursePaymentDetails";
import CourseSlideV3 from "./CourseSlideV3";

class CourseSlideV2 extends Component {
    state = {
        selectMonth: -1,
        selectClassId: 0,
        classDetails: [],
        firstViewModal: false,
        viewModal: false,
        selectedInstallmentId: 0,
        selectedCourseId: -1,
        selectedCourse: {
            totalFee: 0
        },
        selectedTeacher: {
            teacherName: "",
            qualification: "",
            description: "",
            imageUrl: "",
            bankNumber: "",
            bankName: "",
            branchName: "",
            accHolderName: ""
        }
    };

    purchaseHandler = (id, classId, classDetails) => {
        this.props.setPaymentModal(true, {classId: classId, classDetails: classDetails})
    };

    joinClass = (selectClass) => {
        if (this.props.userType === 1) {
            commonFunc.joinClassHandler(this.props, selectClass)

        } else {
            swal({
                title: language[lang].StudentSignInWarning3,
                icon: null,
                closeOnClickOutside: false,
                buttons: {
                    cancel: language[lang].NotNowText,
                    dangerMode: {text: language[lang].OkayText, value: "action", className: "okay-btn"}
                },
            }).then((value) => {
                switch (value) {
                    case "action":
                        window.location = `${constants.BASE_ROUTE}${constants.AUTH_LOGIN_ROUTE}`;
                        break;
                    default:
                        break;
                }
            });
        }
    };

    viewLectureHandler = async (object) => {

        // if (object.fee !== 0) {

        if (webConfig.LMSStatus === 'LMS') {
            this.props.history.push({
                pathname: `${constants.BASE_ROUTE}${constants.HOME_VIEW_CLASS_ROUTE}`,
                state: `${object.id}`
            })
        }
        // }
        // else {
        //     this.props.spinnerHandler({isSpin: true, type: 15});
        //     const data = {
        //         classId: object.id,
        //         studentId: this.props.userObj.id,
        //         year: moment().format('YYYY'),
        //         month: moment().format('MMMM').toUpperCase()
        //     }
        //     await classService.joinFreeClass(data)
        //         .then(response => {
        //             this.props.spinnerHandler(false);
        //             if (response.success) {
        //                 this.props.history.push({
        //                     pathname: `${constants.BASE_ROUTE}${constants.HOME_VIEW_CLASS_ROUTE}`,
        //                     state: `${object.id}`
        //                 })
        //             }else{
        //                 commonFunc.notifyMessage(response.message, 1);
        //                 this.props.history.push({
        //                     pathname: `${constants.BASE_ROUTE}${constants.HOME_VIEW_CLASS_ROUTE}`,
        //                     state: `${object.id}`
        //                 })
        //             }
        //         })
        // }
    };
    viewClassLessons = (object) => {
        commonFunc.viewClassResources(this.props, object.id)
    }

    joinClassHandler = (object) => {
        commonFunc.joinClassHandler(this.props, object)
    };

    render() {
        let {classesByLecture, courses, userType, lecturer, privileges} = this.props;
        let settings = getSliderSetting([{}, {}]);
        let firstWeek = new Date().getDate() <= constants.FREE_CLASS_DURATION;
        console.log(classesByLecture)


        console.log("COURSES : ", courses)

        return (

            <div>

                {this.state.firstViewModal &&
                    <GetPaymentModel history={this.props.history}
                                     courseId={this.state.selectedCourseId}
                                     courseDetails={this.state.selectedCourse} closeModal={() => {
                        this.setState({firstViewModal: false});
                    }}
                                     userType={userType}
                                     paymentModal={(data) => {
                                         this.setState({
                                             viewModal: true,
                                             selectedInstallmentId: data.installmentId,
                                         })
                                     }}
                                     secondNav={true}
                    />
                }


                {this.state.viewModal &&
                    <GetCoursePaymentDetails history={this.props.history} userType={userType}
                                             courseId={this.state.selectedCourseId}
                                             installmentId={this.state.selectedInstallmentId}
                                             totalPayment={this.state.selectedCourse.totalFee}
                                             closeModal={() => {
                                                 this.setState({viewModal: false})
                                             }}
                                             amount={this.state.selectedCourse.totalFee}
                                             teacher={this.state.selectedTeacher}
                    />
                }

                <div className={"slide-show"}>
                    <Slider {...settings} style={{paddingBottom: '10vh'}}>
                        {
                            courses.map((element, index) => {

                                const {
                                    buttonStatus,
                                    nextDayOfClass,
                                    teacherClassResponse,
                                    dayTimes,
                                    imageUrl,
                                    name,
                                    fee,
                                    totalFee,
                                    courseId,
                                    courseInstallmentList
                                } = element;

                                let installmentCount = 1;

                                if (courseInstallmentList) {
                                    installmentCount = courseInstallmentList.length;
                                }

                                // const {teacherName} = teacherClassResponse;

                                return (
                                    <CourseSlideV3 course={element}
                                                   onRegister={(selectedCourseId, selectedCourse, teacher) => {
                                                       this.setState({
                                                           selectedCourseId: selectedCourseId,
                                                           selectedCourse: selectedCourse,
                                                           firstViewModal: true,
                                                           selectedTeacher: teacher
                                                       })
                                                   }}/>
                                    // <div key={courseId}>
                                    //
                                    //     <div className={"slideshow-wrapper shadow"}>
                                    //
                                    //         <Row style={{width: "100%", cursor: 'pointer'}} className={"no-gutters"}>
                                    //             <Col>
                                    //                 <img
                                    //                     onClick={() => {
                                    //                         this.props.history.push({
                                    //                             pathname: `${constants.BASE_ROUTE}${constants.HOME_VIEW_COURSE_ROUTE}`,
                                    //                             state: {id: element.courseId}
                                    //                         })
                                    //                     }}
                                    //                     style={{
                                    //                         objectFit: 'cover',
                                    //                         aspectRatio: "3/1.6",
                                    //                         borderRadius: 8,
                                    //                         cursor: 'pointer'
                                    //                     }}
                                    //                     src={imageUrl} alt={"cover-img"}
                                    //                     width={"100%"}/>
                                    //             </Col>
                                    //         </Row>
                                    //
                                    //         {/*boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px"*/}
                                    //
                                    //         <div style={{padding: 20, borderRadius: 8}} className={"shadow"}>
                                    //
                                    //             <Row>
                                    //                 <Col>
                                    //                     <div style={{
                                    //                         color: 'black',
                                    //                         paddingBottom: 10,
                                    //                         fontSize: 24,
                                    //                         fontWeight: 'bold'
                                    //                     }}>
                                    //                         {name}
                                    //                     </div>
                                    //                     {/*<div style={{*/}
                                    //                     {/*    paddingBottom: 10,*/}
                                    //                     {/*    fontSize: 18*/}
                                    //                     {/*}}>{`Payment can be made in ${installmentCount} installment${installmentCount > 1 ? 's' : ''}`}</div>*/}
                                    //                 </Col>
                                    //             </Row>
                                    //
                                    //             {/*<Row style={{paddingTop: 10, paddingLeft: 10}}>*/}
                                    //             {/*    <Col style={{*/}
                                    //             {/*        display: 'flex',*/}
                                    //             {/*        flexDirection: 'column',*/}
                                    //             {/*        justifyContent: 'center',*/}
                                    //             {/*        alignItems: 'start'*/}
                                    //             {/*    }}>*/}
                                    //
                                    //             {/*        {*/}
                                    //             {/*            dayTimes.length !== 0 &&*/}
                                    //             {/*            <div style={{*/}
                                    //             {/*                color: 'black',*/}
                                    //             {/*                paddingBottom: 10,*/}
                                    //             {/*                fontSize: 20,*/}
                                    //             {/*                fontWeight: 'bold'*/}
                                    //             {/*            }}>*/}
                                    //             {/*                Class Schedule</div>*/}
                                    //             {/*        }*/}
                                    //
                                    //             {/*        <div*/}
                                    //             {/*            style={{display: 'flex', flexDirection: 'column', gap: 15}}>*/}
                                    //
                                    //             {/*            {*/}
                                    //             {/*                dayTimes !== 0 && dayTimes.map((dayTime, i) => (*/}
                                    //             {/*                    <div key={i}*/}
                                    //             {/*                         style={{width: '100%', display: 'flex', gap: 5}}>*/}
                                    //             {/*                        <span>*/}
                                    //             {/*                            <img alt={"date"} width={20} height={20}*/}
                                    //             {/*                                 src={ClockIcon}/>*/}
                                    //             {/*                        </span>*/}
                                    //             {/*                        <div>*/}
                                    //             {/*                            {`${language[lang][dayTime.day]}:  */}
                                    //             {/*                            ${moment(`2000-01-01 ${dayTime.startTime}`).format('h:mm a')} - ${moment(`2000-01-01 ${dayTime.endTime}`).format('h:mm a')}`}*/}
                                    //             {/*                        </div>*/}
                                    //             {/*                    </div>*/}
                                    //             {/*                ))*/}
                                    //             {/*            }*/}
                                    //
                                    //             {/*            {*/}
                                    //             {/*                (nextDayOfClass !== undefined && nextDayOfClass !== null) &&*/}
                                    //             {/*                <div style={{width: '100%', display: 'flex', gap: 5}}>*/}
                                    //             {/*                    <span>*/}
                                    //             {/*                        <img alt={"date"} width={20} height={20}*/}
                                    //             {/*                             src={DateIcon}/>*/}
                                    //             {/*                    </span>*/}
                                    //             {/*                    <div style={{}}>Next Class is*/}
                                    //             {/*                        on {` ${moment(nextDayOfClass.replace("Z", "")).format("YYYY MMM DD ")}`}*/}
                                    //             {/*                    </div>*/}
                                    //             {/*                </div>*/}
                                    //             {/*            }*/}
                                    //
                                    //             {/*        </div>*/}
                                    //
                                    //             {/*    </Col>*/}
                                    //             {/*</Row>*/}
                                    //
                                    //             <Row className={"no-gutters"} style={{paddingTop: 20}}>
                                    //                 <Col style={{
                                    //                     display: 'flex',
                                    //                     flexDirection: 'column',
                                    //                     gap: 10
                                    //                 }}>
                                    //                     <button
                                    //                         onClick={() => {
                                    //                             this.props.history.push({
                                    //                                 pathname: `${constants.BASE_ROUTE}${constants.HOME_VIEW_COURSE_ROUTE}`,
                                    //                                 state: {id: element.courseId}
                                    //                             })
                                    //                         }}
                                    //                         style={{
                                    //                             width: '100%',
                                    //                             borderRadius: 8,
                                    //                             color: 'white',
                                    //                             padding: 20,
                                    //                             backgroundColor: "maroon"
                                    //                         }}>FIND
                                    //                         OUT MORE
                                    //                     </button>
                                    //                     <button
                                    //                         onClick={() => {
                                    //                             this.setState({
                                    //                                 selectedCourseId: courseId,
                                    //                                 selectedCourse: element,
                                    //                                 firstViewModal: true
                                    //                             })
                                    //                         }}
                                    //                         style={{
                                    //                             borderRadius: 8,
                                    //                             width: '100%',
                                    //                             color: 'white',
                                    //                             backgroundColor: '#344054',
                                    //                             padding: 20
                                    //                         }}>REGISTER FOR THIS COURSE
                                    //                     </button>
                                    //                     {/*<button style={{*/}
                                    //                     {/*    borderRadius: 8,*/}
                                    //                     {/*    width: '100%',*/}
                                    //                     {/*    color: 'white',*/}
                                    //                     {/*    backgroundColor: '#344054',*/}
                                    //                     {/*    padding: 20*/}
                                    //                     {/*}}>WATCH VIDEOS AND PDF*/}
                                    //                     {/*</button>*/}
                                    //                 </Col>
                                    //             </Row>
                                    //
                                    //         </div>
                                    //
                                    //     </div>
                                    // </div>
                                )
                            })
                        }
                    </Slider>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    userType: state.auth.userType,
    lecturer: state.lecturer.lecturer,
    userObj: state.student.userObj
});

const mapDispatchToProps = (dispatch) => ({
    selectClassHandler: data => dispatch(actionCreator.selectClass(data)),
    spinnerHandler: data => dispatch(actionSpinnerCreator.spinnerHandler(data)),
    setPaymentModal: (data, value) => dispatch(actionModalCreator.setPaymentModal(data, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CourseSlideV2));
